import { combineReducers } from '@reduxjs/toolkit';

import { creditPoolReducer } from './creditPool/creditPool.slices';
import { creditsPoolsReducer } from './creditsPools/creditsPools.slice';
import { drawdownsReducer } from './drawdowns/drawdowns.slice';
import { drawdownReducer } from './drawdown/drawdown.slice';
import { creditsDistributionReducer } from './distribution';

export const creditsReducers = combineReducers({
  creditPool: creditPoolReducer,
  creditsPools: creditsPoolsReducer,
  drawdown: drawdownReducer,
  drawdowns: drawdownsReducer,
  distribution: creditsDistributionReducer
});
